document.addEventListener('DOMContentLoaded', function () {
  // 画像が更新されたかどうかを追跡するフラグ
  let logoUpdated = false;
  let bannerUpdated = false;

  // ロゴ画像の更新を検知
  const logoInput = document.getElementById('company_logo_image_form');
  if (logoInput) {
    logoInput.addEventListener('change', function (e) {
      logoUpdated = true;
      // ファイルアップロード時のプレビュー機能
      if (e.target.files && e.target.files[0]) {
        const reader = new FileReader();
        reader.onload = function (e) {
          // 編集画面のプレビュー用の画像を更新
          const logoImage = document.getElementById('company_logo_image');
          if (logoImage) {
            logoImage.src = e.target.result;
          }
        }
        reader.readAsDataURL(e.target.files[0]);
      }
    });
  }

  // バナー画像の更新を検知
  const bannerInput = document.getElementById('company_banner_image_form');
  if (bannerInput) {
    bannerInput.addEventListener('change', function (e) {
      bannerUpdated = true;
      // ファイルアップロード時のプレビュー機能
      if (e.target.files && e.target.files[0]) {
        const reader = new FileReader();
        reader.onload = function (e) {
          // 編集画面のプレビュー用の画像を更新
          const bannerImage = document.getElementById('company_banner_image');
          if (bannerImage) {
            bannerImage.src = e.target.result;
          }
        }
        reader.readAsDataURL(e.target.files[0]);
      }
    });
  }

  // プレビューボタンのクリックイベント
  const previewButton = document.getElementById('preview-button');
  const previewModal = document.getElementById('preview-modal');
  const closePreviewModal = document.getElementById('close-preview-modal');

  if (previewButton && previewModal && closePreviewModal) {
    previewButton.addEventListener('click', function () {
      // フォームの値を取得してプレビューに反映
      updatePreview();
      previewModal.classList.remove('hidden');
      previewModal.classList.add('flex');
    });

    closePreviewModal.addEventListener('click', function () {
      previewModal.classList.add('hidden');
      previewModal.classList.remove('flex');
    });

    // モーダルの外側をクリックしたときに閉じる
    previewModal.addEventListener('click', function (e) {
      if (e.target === previewModal) {
        previewModal.classList.add('hidden');
        previewModal.classList.remove('flex');
      }
    });
  }

  // プレビューの内容を更新する関数
  function updatePreview() {
    // 企業名（ヘッダー部分とリスト部分）
    document.getElementById('preview-company-name').textContent = document.querySelector('input[name="company[name]"]').value;
    document.getElementById('preview-company-name-full').textContent = document.querySelector('input[name="company[name]"]').value;

    // 所在地
    const prefecture = document.querySelector('select[name="company[prefecture]"] option:checked').text;
    const city = document.querySelector('input[name="company[city]"]').value;
    const address = document.querySelector('input[name="company[address]"]').value;
    document.getElementById('preview-address').textContent = `${prefecture} ${city} ${address}`;

    // 他の拠点
    document.getElementById('preview-branch').textContent = document.querySelector('input[name="company[branch]"]').value;

    // 主な製品/サービス
    document.getElementById('preview-service').textContent = document.querySelector('input[name="company[service]"]').value;

    // 資本金
    const capitalValue = document.querySelector('input[name="company[capital]"]').value;
    // 空白を除去して数値に変換
    const capitalNum = parseInt(capitalValue.replace(/\s+/g, ''), 10);
    if (!isNaN(capitalNum)) {
      // 1万円単位で表示（例: 15000000 → 1,500万円）
      const capitalInMan = capitalNum / 10000;
      document.getElementById('preview-capital').textContent = capitalInMan.toLocaleString() + '万円';
    } else {
      document.getElementById('preview-capital').textContent = capitalValue ? capitalValue + '円' : '';
    }

    // 従業員数
    document.getElementById('preview-employees-number').textContent = document.querySelector('select[name="company[employees_number]"] option:checked').text;

    // 事業内容・特徴
    document.getElementById('preview-description').textContent = document.querySelector('textarea[name="company[description]"]').value;

    // 担当者部署
    document.getElementById('preview-department').textContent = document.querySelector('input[name="department"]').value;

    // 担当者姓名
    const lastName = document.querySelector('input[name="last_name"]').value;
    const firstName = document.querySelector('input[name="first_name"]').value;
    document.getElementById('preview-user-name').textContent = `${lastName} ${firstName}`;

    // ご挨拶
    document.getElementById('preview-greeting').textContent = document.querySelector('textarea[name="company[greeting]"]').value;

    // 企業URLリンク
    const urlLink = document.getElementById('preview-url-link');
    const companyUrl = document.querySelector('input[name="company[url]"]').value;
    if (urlLink) {
      urlLink.href = companyUrl || '#';

      // URLが空の場合は非表示、URLがある場合は表示
      const urlContainer = document.getElementById('preview-url-container');
      if (urlContainer && !companyUrl) {
        urlContainer.style.display = 'none';
      } else if (urlContainer && companyUrl) {
        urlContainer.style.display = 'block';
      }
    }

    // ロゴ画像のプレビュー更新（新しい画像が選択された場合のみ）
    if (logoUpdated) {
      const previewLogo = document.getElementById('preview-logo');
      const companyLogoImage = document.getElementById('company_logo_image');
      if (previewLogo && companyLogoImage && companyLogoImage.getAttribute('src')) {
        previewLogo.src = companyLogoImage.src;
      }
    }

    // バナー画像のプレビュー更新（新しい画像が選択された場合のみ）
    if (bannerUpdated) {
      const previewBanner = document.getElementById('preview-banner');
      const companyBannerImage = document.getElementById('company_banner_image');
      if (previewBanner && companyBannerImage && companyBannerImage.getAttribute('src')) {
        previewBanner.src = companyBannerImage.src;
      }
    }
  }
});
